(() => {
  const DESKTOP_TARGET_TEMPLATE = 'product-food-gel';
  const MOBILE_QUERY = '(max-width: 749px)';
  const BADGE_SELECTOR = '.kmc-product-image-badges';
  const MEDIA_SELECTOR = '.product__media-wrapper .product__media-item.is-active .product-media-container, .product__media-wrapper .product-media-container';
  const FERA_SELECTOR = '[id*="fera_product_reviews_summary"], [data-fera-container*="product_reviews_summary"], .rating-wrapper';
  const APPSTLE_SELECTOR = [
    '#appstle_subscription_widget0',
    '[id^="appstle_subscription_widget"]',
    '.appstle_sub_widget',
    '.appstle_subscription_wrapper',
    '[data-appstle-subscription-widget]',
    '[id*="appstle_subscription_product_page_widget"]'
  ].join(', ');

  const targetProductInfo = (root = document) => {
    const items = Array.from(root.querySelectorAll?.('product-info[data-product-template]') || []);
    if (root.matches?.('product-info[data-product-template]')) items.unshift(root);
    return [...new Set(items)].filter((item) => item.closest('#MainContent[data-template="product"]'));
  };

  const directChild = (node, parent) => {
    let current = node;
    while (current && current.parentElement && current.parentElement !== parent) current = current.parentElement;
    return current?.parentElement === parent ? current : null;
  };

  const rememberPosition = (node, key) => {
    if (!node || node.dataset.kmcMobileLayoutNode) return;
    const marker = document.createElement('span');
    marker.hidden = true;
    marker.dataset.kmcMobileLayoutMarker = key;
    node.parentElement.insertBefore(marker, node);
    node.dataset.kmcMobileLayoutNode = key;
  };

  const restorePosition = (productInfo, key) => {
    const node = productInfo.querySelector('[data-kmc-mobile-layout-node="' + key + '"]');
    const marker = productInfo.querySelector('[data-kmc-mobile-layout-marker="' + key + '"]');
    if (!node || !marker || !marker.parentElement) return;
    marker.parentElement.insertBefore(node, marker);
    marker.remove();
    delete node.dataset.kmcMobileLayoutNode;
  };

  const applyBadgeStyles = (badge) => {
    if (badge.dataset.kmcOriginalInlineStyle === undefined) {
      badge.dataset.kmcOriginalInlineStyle = badge.getAttribute('style') || '';
    }
    Object.assign(badge.style, {
      position: 'absolute', left: 'auto', top: 'auto', right: '1.1rem', bottom: '1.1rem',
      zIndex: '50', display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end',
      alignItems: 'flex-end', gap: '.55rem', width: 'auto',
      maxWidth: 'calc(100% - 2.2rem)', margin: '0', transform: 'none', pointerEvents: 'none'
    });
  };

  const fixImageBadges = (productInfo) => {
    const mediaContainer = productInfo.querySelector(MEDIA_SELECTOR);
    const badge = productInfo.querySelector(BADGE_SELECTOR);
    if (!mediaContainer || !badge) return;
    mediaContainer.style.position = 'relative';
    rememberPosition(badge, 'badges');
    if (badge.parentElement !== mediaContainer) mediaContainer.insertBefore(badge, mediaContainer.firstChild);
    applyBadgeStyles(badge);
  };

  const moveFeraFirst = (productInfo) => {
    const container = productInfo.querySelector('.product__info-container');
    const fera = container?.querySelector(FERA_SELECTOR);
    const block = fera && directChild(fera, container);
    if (!container || !block) return;
    rememberPosition(block, 'reviews');
    if (container.firstElementChild !== block) container.insertBefore(block, container.firstElementChild);
  };

  const appstleMovableNode = (widget, container) => {
    let current = widget;
    while (current.parentElement && current.parentElement !== container) {
      const parentSignature = (current.parentElement.id + ' ' + current.parentElement.className).toLowerCase();
      if (!parentSignature.includes('appstle') && !parentSignature.includes('subscription')) break;
      current = current.parentElement;
    }
    return current;
  };

  const moveAppstleBeforeVariants = (productInfo) => {
    const container = productInfo.querySelector('.product__info-container');
    const variant = container?.querySelector('variant-selects');
    if (!container || !variant) return;
    const widget = Array.from(productInfo.querySelectorAll(APPSTLE_SELECTOR))
      .find((element) => !/loyalty|acquire.points/i.test(element.id + ' ' + element.className));
    if (!widget) return;
    const variantBlock = directChild(variant, container);
    const movable = appstleMovableNode(widget, container);
    if (!variantBlock || !movable || movable === variantBlock) return;
    rememberPosition(movable, 'appstle');
    if (variantBlock.previousElementSibling !== movable) container.insertBefore(movable, variantBlock);
  };

  const restoreDesktopLayout = (productInfo) => {
    const badge = productInfo.querySelector('[data-kmc-mobile-layout-node="badges"]');
    restorePosition(productInfo, 'appstle');
    restorePosition(productInfo, 'reviews');
    restorePosition(productInfo, 'badges');
    if (badge) {
      const original = badge.dataset.kmcOriginalInlineStyle || '';
      if (original) badge.setAttribute('style', original);
      else badge.removeAttribute('style');
      delete badge.dataset.kmcOriginalInlineStyle;
    }
  };

  const run = (root = document) => {
    const isMobile = window.matchMedia(MOBILE_QUERY).matches;
    targetProductInfo(root).forEach((productInfo) => {
      const keepCompact = isMobile || productInfo.dataset.productTemplate === DESKTOP_TARGET_TEMPLATE;
      if (!keepCompact) {
        restoreDesktopLayout(productInfo);
        return;
      }
      fixImageBadges(productInfo);
      moveFeraFirst(productInfo);
      moveAppstleBeforeVariants(productInfo);
    });
  };

  let scheduled = false;
  const schedule = (root = document) => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run());
  else run();

  const observer = new MutationObserver(() => schedule());
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => schedule(event.target));
  document.addEventListener('shopify:block:select', () => schedule());
  document.addEventListener('variant:change', () => schedule());
  window.addEventListener('resize', () => schedule());
  setTimeout(() => run(), 600);
  setTimeout(() => run(), 1400);
})();
